// Single source of truth for the platform support / contact email shown to club owners
// (suspended/archived panels, platform payment help, etc.). Keep in sync with the
// backend SUPPORT_EMAIL / PLATFORM_SUPPORT_CONTACT env vars.
export const SUPPORT_EMAIL = 'anushdhakal2073@gmail.com';
